// components/Modals/ContentModal/tabs/SocialMediaTab.js
import React, { useState, useEffect, useRef } from 'react';
import './SocialMediaTab.css';
import { toast } from 'react-hot-toast';
import EmojiPicker from 'emoji-picker-react';
import QuickButtonSelector from '../components/QuickButtonSelector';

const SocialMediaTab = ({
    platformSettings,
    setPlatformSettings,
    telegramSettings,
    setTelegramSettings,
    youtubeSettings,
    setYoutubeSettings,
    buttonForm,
    setButtonForm,
    currentButton,
    setCurrentButton,
    contentForm,
    setContentForm,
    showEmojiPicker,
    setShowEmojiPicker,
    showLinkModal,
    setShowLinkModal,
    linkData,
    setLinkData,
    mediaPreviews,
    isEditMode = false,
    existingMedia = [],
    xSettings,
    setXSettings,
    tiktokSettings,
    setTiktokSettings,
    instagramSettings,
    setInstagramSettings,
    selectedTagIds = [],
    tags = [],
    bulkMode = false

}) => {
    // Girls etiketi kontrolü
    const hasGirlsTag = tags.some(tag =>
        selectedTagIds.includes(tag.id) &&
        tag.name.toLowerCase().includes('girls')
    );
    // Genişletilmiş platform state'i
    const [expandedPlatform, setExpandedPlatform] = useState(null);
    const [isButtonsExpanded, setIsButtonsExpanded] = useState(false);
    const [localYoutubeForm, setLocalYoutubeForm] = useState({
        title: youtubeSettings.title || '',
        description: youtubeSettings.description || '',
        categoryId: youtubeSettings.categoryId || '24'
    });

    // Video süresini hesapla
    const [videoDuration, setVideoDuration] = useState(null);
    const [videoType, setVideoType] = useState(null); // 'shorts' veya 'video'

    // Context Menu (Sağ Tık Menüsü) State'leri
    const [contextMenu, setContextMenu] = useState({
        visible: false,
        x: 0,
        y: 0,
        selectedText: '',
        selectionStart: 0,
        selectionEnd: 0
    });
    const textareaRef = useRef(null);
    const contextMenuRef = useRef(null);

    // YouTube kategorileri
    const youtubeCategories = [
        { id: '1', name: 'Film ve Animasyon' },
        { id: '2', name: 'Otomobiller ve Araçlar' },
        { id: '10', name: 'Müzik' },
        { id: '15', name: 'Evcil Hayvanlar ve Hayvanlar' },
        { id: '17', name: 'Spor' },
        { id: '19', name: 'Seyahat ve Etkinlikler' },
        { id: '20', name: 'Oyun' },
        { id: '22', name: 'İnsanlar ve Bloglar' },
        { id: '23', name: 'Komedi' },
        { id: '24', name: 'Eğlence' },
        { id: '25', name: 'Haberler ve Politika' },
        { id: '26', name: 'Nasıl Yapılır ve Stil' },
        { id: '27', name: 'Eğitim' },
        { id: '28', name: 'Bilim ve Teknoloji' }
    ];

    const [showQuickButtonModal, setShowQuickButtonModal] = useState(false);

    // Platform listesi
    const platforms = [
        {
            id: 'telegram',
            name: 'Telegram',
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                </svg>
            ),
            status: 'active',
            description: 'Telegram kanallarına otomatik içerik paylaşımı'
        },
        {
            id: 'youtube',
            name: 'YouTube',
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
            ),
            status: 'active',
            description: 'YouTube Shorts ve Video yükleme'
        },
        {
            id: 'x',
            name: 'X (Twitter)',
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
            ),
            status: 'active',
            description: 'X platformuna otomatik tweet paylaşımı (280 karakter)'
        },
        {
            id: 'tiktok',
            name: 'TikTok',
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
                </svg>
            ),
            status: 'active',
            description: 'TikTok videolarını otomatik paylaşma'
        },
        {
            id: 'instagram',
            name: 'Instagram',
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z" />
                </svg>
            ),
            status: 'active',
            description: 'Instagram Post, Reels ve Story paylaşımı'
        }
    ];

    const getStatusColor = (status) => {
        switch (status) {
            case 'active': return '#10B981';
            case 'coming': return '#F59E0B';
            case 'inactive': return '#6B7280';
            default: return '#6B7280';
        }
    };

    const getPlatformColor = (platformId) => {
        switch (platformId) {
            case 'telegram': return '#0088CC';
            case 'youtube': return '#FF0000';
            case 'x': return '#000000';
            case 'tiktok': return '#000000';
            case 'instagram': return '#E4405F';
            default: return '#6B7280';
        }
    };

    // Platform listesini filtrele
    const getFilteredPlatforms = () => {
        // Bulk mode'da tüm platformları göster
        if (bulkMode) return platforms;

        const hasVideo = mediaPreviews.some(p => p.type === 'video') ||
            (isEditMode && existingMedia.some(m => m?.type === 'video' || m?.mimetype?.startsWith('video/')));

        const hasPhoto = mediaPreviews.some(p => p.type === 'image') ||
            (isEditMode && existingMedia.some(m => m?.type === 'image' || m?.mimetype?.startsWith('image/')));

        return platforms.filter(platform => {
            // YouTube ve TikTok sadece video varsa ve fotoğraf yoksa göster
            if (platform.id === 'youtube' || platform.id === 'tiktok') {
                return hasVideo && !hasPhoto;
            }
            return true;
        });
    };

    // Video süresini hesapla (mevcut medya veya yeni yüklenen)
    useEffect(() => {
        console.log('🔍 Video Duration Check Started');
        console.log('  - mediaPreviews:', mediaPreviews);
        console.log('  - isEditMode:', isEditMode);
        console.log('  - existingMedia:', existingMedia);
        console.log('  - contentForm:', contentForm);
        console.log('  - contentForm.video_duration:', contentForm?.video_duration);

        const checkVideoDuration = async () => {
            // 1. Yeni yüklenen video var mı?
            const newVideo = mediaPreviews.find(p => p.type === 'video');
            console.log('  - newVideo:', newVideo);

            if (newVideo && newVideo.file) {
                console.log('  ✅ Yeni video bulundu, süre hesaplanıyor...');
                try {
                    const video = document.createElement('video');
                    video.preload = 'metadata';

                    video.onloadedmetadata = () => {
                        const duration = Math.round(video.duration);
                        setVideoDuration(duration);
                        setVideoType(duration <= 60 ? 'shorts' : 'video');
                        console.log(`  ✅ Video duration: ${duration}s - Type: ${duration <= 60 ? 'Shorts' : 'Video'}`);
                        URL.revokeObjectURL(video.src);
                    };

                    video.src = URL.createObjectURL(newVideo.file);
                } catch (error) {
                    console.error('  ❌ Video duration calculation error:', error);
                }
            }
            // 2. Edit modda mevcut video var mı ve video_duration var mı?
            else if (isEditMode && contentForm?.video_duration !== undefined && contentForm?.video_duration !== null) {
                console.log('  ✅ Edit modda video_duration bulundu:', contentForm.video_duration);
                const duration = contentForm.video_duration;
                setVideoDuration(duration);
                setVideoType(duration <= 60 ? 'shorts' : 'video');
                console.log(`  ✅ Existing video duration: ${duration}s - Type: ${duration <= 60 ? 'Shorts' : 'Video'}`);
            }
            // 3. Video var ama süre yok - hata durumu
            else if (isEditMode && existingMedia.length > 0) {
                console.log('  🔍 Existing media kontrolü yapılıyor...');
                const hasVideo = existingMedia.some(m => {
                    console.log('    - Checking media:', m);
                    return m?.type === 'video' || m?.mimetype?.startsWith('video/');
                });
                console.log('  - hasVideo:', hasVideo);

                if (hasVideo) {
                    console.log('  ⚠️ Video var ama video_duration bilgisi backend\'den gelmiyor!');
                    console.log('  ⚠️ Backend\'e video_duration eklendiğinden emin olun.');
                    setVideoDuration(null);
                    setVideoType(null);
                }
            } else {
                console.log('  ℹ️ Video bulunamadı, state sıfırlanıyor');
                setVideoDuration(null);
                setVideoType(null);
            }
        };

        checkVideoDuration();
    }, [mediaPreviews, isEditMode, existingMedia, contentForm]);

    // YouTube ayarlarını güncelle
    useEffect(() => {
        if (localYoutubeForm) {
            setYoutubeSettings({
                ...youtubeSettings,
                title: localYoutubeForm.title,
                description: localYoutubeForm.description,
                categoryId: localYoutubeForm.categoryId
            });
        }
    }, [localYoutubeForm]);

    // Context Menu'yü kapat (dışarı tıklama)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
                setContextMenu(prev => ({ ...prev, visible: false }));
            }
        };

        if (contextMenu.visible) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [contextMenu.visible]);

    // Sağ Tık Event Handler
    const handleContextMenu = (e) => {
        e.preventDefault();

        const textarea = textareaRef.current;
        if (!textarea) return;

        const selectedText = textarea.value.substring(
            textarea.selectionStart,
            textarea.selectionEnd
        );

        // Metin seçilmemişse menüyü gösterme
        if (!selectedText) {
            setContextMenu(prev => ({ ...prev, visible: false }));
            return;
        }

        // Menü konumunu hesapla
        setContextMenu({
            visible: true,
            x: e.clientX,
            y: e.clientY,
            selectedText: selectedText,
            selectionStart: textarea.selectionStart,
            selectionEnd: textarea.selectionEnd
        });
    };

    // Telegram Markdown Biçimlendirme Fonksiyonu
    const applyFormatting = (formatType) => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const { selectionStart, selectionEnd, selectedText } = contextMenu;
        const content = contentForm.content || '';

        let formattedText = '';
        let tagLength = 0;

        switch (formatType) {
            case 'bold':
                formattedText = `<b>${selectedText}</b>`;
                tagLength = 7; // <b></b>
                break;
            case 'italic':
                formattedText = `<i>${selectedText}</i>`;
                tagLength = 7; // <i></i>
                break;
            case 'code':
                formattedText = `<code>${selectedText}</code>`;
                tagLength = 13; // <code></code>
                break;
            case 'strikethrough':
                formattedText = `<s>${selectedText}</s>`;
                tagLength = 7; // <s></s>
                break;
            case 'underline':
                formattedText = `<u>${selectedText}</u>`;
                tagLength = 7; // <u></u>
                break;
            case 'spoiler':
                formattedText = `<tg-spoiler>${selectedText}</tg-spoiler>`;
                tagLength = 25; // <tg-spoiler></tg-spoiler>
                break;
            case 'monospace':
                formattedText = `<pre>${selectedText}</pre>`;
                tagLength = 11; // <pre></pre>
                break;
            default:
                return;
        }

        const newContent =
            content.substring(0, selectionStart) +
            formattedText +
            content.substring(selectionEnd);

        setContentForm({ ...contentForm, content: newContent });
        setContextMenu(prev => ({ ...prev, visible: false }));

        const newCursorPos = selectionStart + selectedText.length + tagLength;
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(newCursorPos, newCursorPos);
        }, 0);

        toast.success('Biçimlendirme uygulandı');
    };

    // Platform tıklama işlemi
    const handlePlatformClick = (platformId) => {
        const platform = platforms.find(p => p.id === platformId);

        if (platform.status !== 'active') {
            toast.error('Bu platform henüz kullanılamıyor');
            return;
        }

        // YouTube ve TikTok için video kontrolü - bulk mode'da atla
        if (!bulkMode && (platformId === 'youtube' || platformId === 'tiktok')) {
            const hasVideo = mediaPreviews.some(p => p.type === 'video') ||
                (isEditMode && existingMedia.some(m => m?.type === 'video' || m?.mimetype?.startsWith('video/')));

            const hasPhoto = mediaPreviews.some(p => p.type === 'image') ||
                (isEditMode && existingMedia.some(m => m?.type === 'image' || m?.mimetype?.startsWith('image/')));

            if (!hasVideo) {
                if (hasPhoto) {
                    toast.error(`${platform.name} sadece video içerikler için kullanılabilir`);
                } else {
                    toast.error(`${platform.name} için video yüklemeniz gerekiyor`);
                }
                return;
            }

            // TikTok için video süresi kontrolü
            if (platformId === 'tiktok' && videoDuration && videoDuration > 180) {
                toast.warning('TikTok videoları maksimum 3 dakika olabilir');
            }
        }

        // Eğer zaten genişletilmişse ve seçiliyse, kapat
        if (expandedPlatform === platformId && platformSettings[platformId]) {
            setExpandedPlatform(null);
            setPlatformSettings(prev => ({
                ...prev,
                [platformId]: false
            }));
        } else {
            // Diğer platformları kapat ve yenisini aç
            const newSettings = {};
            platforms.forEach(p => {
                newSettings[p.id] = p.id === platformId;
            });
            setPlatformSettings(newSettings);
            setExpandedPlatform(platformId);
        }
    };

    // QuickButtonSelector'dan gelen buton ekleme
    const handleQuickButtonAdd = (button) => {
        const newButtonForm = Array.isArray(buttonForm) ? [...buttonForm] : [];

        if (newButtonForm.length === 0 || !Array.isArray(newButtonForm[newButtonForm.length - 1])) {
            newButtonForm.push([]);
        }

        const lastRow = newButtonForm[newButtonForm.length - 1];
        if (lastRow.length < 3) {
            lastRow.push(button);
        } else {
            newButtonForm.push([button]);
        }

        setButtonForm(newButtonForm);
        setTelegramSettings(prev => ({
            ...prev,
            buttons: newButtonForm
        }));
    };

    // Telegram buton silme
    const handleRemoveButton = (rowIndex, buttonIndex) => {
        const newButtonForm = [...buttonForm];
        newButtonForm[rowIndex].splice(buttonIndex, 1);

        if (newButtonForm[rowIndex].length === 0) {
            newButtonForm.splice(rowIndex, 1);
        }

        setButtonForm(newButtonForm);
        setTelegramSettings(prev => ({
            ...prev,
            buttons: newButtonForm
        }));
        toast.success('Buton silindi');
    };

    // Emoji ekleme (Telegram için)
    const handleEmojiClick = (emojiObject) => {
        const newContent = contentForm.content + emojiObject.emoji;
        setContentForm({ ...contentForm, content: newContent });
        setShowEmojiPicker(false);
    };

    // Link modal işlemleri
    const handleInsertLink = () => {
        if (!linkData.text || !linkData.url) {
            toast.error('Metin ve URL zorunludur');
            return;
        }

        // Telegram HTML link formatı
        const link = `[${linkData.text}](${linkData.url})`;
        const newContent = contentForm.content + link;
        setContentForm({ ...contentForm, content: newContent });
        setShowLinkModal(false);
        setLinkData({ text: '', url: '' });
        toast.success('Link eklendi');
    };

    // Platform detaylarını render et
    const renderPlatformDetails = (platform) => {
        if (platform.id === 'telegram') {
            return (
                <div className="smt-details-panel">
                    <div className="smt-telegram-settings">
                        {/* İçerik Alanı */}
                        <div className="smt-form-group">
                            <label>İçerik Metni</label>

                            {/* Araç Çubuğu */}
                            <div className="smt-textarea-tools-top">
                                <button
                                    type="button"
                                    className="smt-tool-btn"
                                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                                >
                                    😊 Emoji
                                </button>
                                <button
                                    type="button"
                                    className="smt-tool-btn"
                                    onClick={() => setShowLinkModal(true)}
                                >
                                    🔗 Link Ekle
                                </button>
                                <span className="smt-char-count">
                                    {contentForm.content?.length || 0} / 4096
                                </span>
                            </div>

                            {/* Biçimlendirme İpucu */}
                            <div className="smt-formatting-hint">
                                💡 Metni seçip sağ tıklayarak Telegram biçimlendirmesi yapabilirsiniz
                            </div>

                            <div className="smt-textarea-wrapper smt-richtext-wrapper">
                                {contentForm.content && /\[([^\]]+)\]\(([^)]+)\)/.test(contentForm.content) && (
                                    <div
                                        className="smt-richtext-overlay"
                                        dangerouslySetInnerHTML={{
                                            __html: (() => {
                                                let text = contentForm.content || '';
                                                text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                                                text = text.replace(
                                                    /\[([^\]]+)\]\(([^)]+)\)/g,
                                                    '<a class="smt-inline-link" title="$2">$1</a>'
                                                );
                                                text = text.replace(/\n/g, '<br>');
                                                return text;
                                            })()
                                        }}
                                    />
                                )}
                                <textarea
                                    ref={textareaRef}
                                    value={contentForm.content || ''}
                                    onChange={(e) => setContentForm({ ...contentForm, content: e.target.value })}
                                    onContextMenu={handleContextMenu}
                                    placeholder="Telegram'da paylaşılacak içerik metni..."
                                    rows={8}
                                    maxLength={4096}
                                    className={contentForm.content && /\[([^\]]+)\]\(([^)]+)\)/.test(contentForm.content) ? 'smt-has-links' : ''}
                                />
                            </div>

                            {/* Context Menu (Sağ Tık Menüsü) - Telegram Markdown */}
                            {contextMenu.visible && (
                                <div
                                    ref={contextMenuRef}
                                    className="smt-context-menu"
                                    style={{
                                        position: 'fixed',
                                        left: `${contextMenu.x}px`,
                                        top: `${contextMenu.y}px`,
                                        zIndex: 10000
                                    }}
                                >
                                    <button
                                        type="button"
                                        onClick={() => applyFormatting('bold')}
                                        className="smt-context-menu-item"
                                    >
                                        <span className="smt-menu-icon">🅱️</span>
                                        <span>Kalın</span>
                                        <span className="smt-menu-tag">{"<b>text</b>"}</span>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => applyFormatting('italic')}
                                        className="smt-context-menu-item"
                                    >
                                        <span className="smt-menu-icon">📝</span>
                                        <span>İtalik</span>
                                        <span className="smt-menu-tag">{"<i>text</i>"}</span>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => applyFormatting('code')}
                                        className="smt-context-menu-item"
                                    >
                                        <span className="smt-menu-icon">💻</span>
                                        <span>Kod</span>
                                        <span className="smt-menu-tag">{"<code>text</code>"}</span>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => applyFormatting('strikethrough')}
                                        className="smt-context-menu-item"
                                    >
                                        <span className="smt-menu-icon">─</span>
                                        <span>Üstü Çizili</span>
                                        <span className="smt-menu-tag">{"<s>text</s>"}</span>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => applyFormatting('underline')}
                                        className="smt-context-menu-item"
                                    >
                                        <span className="smt-menu-icon">__</span>
                                        <span>Alt Çizili</span>
                                        <span className="smt-menu-tag">{"<u>text</u>"}</span>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => applyFormatting('spoiler')}
                                        className="smt-context-menu-item"
                                    >
                                        <span className="smt-menu-icon">👁️</span>
                                        <span>Spoiler</span>
                                        <span className="smt-menu-tag">{"<tg-spoiler>"}</span>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => applyFormatting('monospace')}
                                        className="smt-context-menu-item"
                                    >
                                        <span className="smt-menu-icon">⌨️</span>
                                        <span>Monospace</span>
                                        <span className="smt-menu-tag">{"<pre>text</pre>"}</span>
                                    </button>
                                </div>
                            )}

                            {/* Emoji Picker Modal */}
                            {showEmojiPicker && (
                                <>
                                    <div className="smt-emoji-overlay" onClick={() => setShowEmojiPicker(false)} />
                                    <div className="smt-emoji-picker-modal">
                                        <EmojiPicker
                                            onEmojiClick={handleEmojiClick}
                                            searchPlaceHolder=""
                                            width={350}
                                            height={450}
                                            previewConfig={{
                                                showPreview: false
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Mevcut Butonlar - Telegram Tarzı (Her zaman görünür) */}
                        {buttonForm && buttonForm.length > 0 && (
                            <div className="smt-telegram-buttons-preview">
                                {buttonForm.map((row, rowIndex) => (
                                    <div key={rowIndex} className="smt-telegram-button-row">
                                        {Array.isArray(row) ? (
                                            // Row bir array ise (nested yapı: [[btn1, btn2], [btn3]])
                                            row.map((button, buttonIndex) => (
                                                <div key={buttonIndex} className="smt-telegram-button">
                                                    <span className="smt-telegram-button-text">{button.text}</span>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveButton(rowIndex, buttonIndex)}
                                                        className="smt-telegram-button-remove"
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))
                                        ) : (
                                            // Row bir obje ise (flat yapı: [btn1, btn2])
                                            <div className="smt-telegram-button">
                                                <span className="smt-telegram-button-text">{row.text}</span>
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveButton(rowIndex, 0)}
                                                    className="smt-telegram-button-remove"
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* QuickButtonSelector - Her zaman görünür */}
                        <div className="smt-button-selector-wrapper">
                            <QuickButtonSelector
                                onButtonAdd={handleQuickButtonAdd}
                                currentButton={currentButton}
                                setCurrentButton={setCurrentButton}
                                showAddForm={isButtonsExpanded}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        if (platform.id === 'youtube') {
            const hasVideo = bulkMode || mediaPreviews.some(p => p.type === 'video') ||
                (isEditMode && existingMedia.some(m => m?.type === 'video' || m?.mimetype?.startsWith('video/')));

            const isShortsEnabled = bulkMode || videoType === 'shorts';
            const isVideoEnabled = bulkMode || videoType === 'video';

            return (
                <div className="smt-details-panel">
                    <div className="smt-youtube-settings">
                        {/* Video Kontrolü */}
                        {!hasVideo && (
                            <div className="smt-warning-box">
                                <span>⚠️</span>
                                <p>YouTube için video yüklemeniz gerekiyor. Medya sekmesinden video ekleyin.</p>
                            </div>
                        )}

                        {/* Video Süresi Bilgisi */}
                        {hasVideo && videoDuration && (
                            <div className="smt-info-box">
                                <span>🎬</span>
                                <p>
                                    Video süresi: <strong>{videoDuration} saniye</strong>
                                    {isShortsEnabled && ' - YouTube Shorts için uygun'}
                                    {isVideoEnabled && ' - Normal YouTube Video olarak yüklenecek'}
                                </p>
                            </div>
                        )}

                        {/* YouTube Shorts Bölümü */}
                        <div className={`smt-youtube-section ${!isShortsEnabled ? 'disabled' : ''}`}>
                            <div className="smt-section-header">
                                <h4>YouTube Shorts {isShortsEnabled ? '(Aktif)' : '(Devre Dışı)'}</h4>
                                {!isShortsEnabled && videoDuration && (
                                    <span className="smt-disabled-reason">Video 60 saniyeden uzun</span>
                                )}
                            </div>

                            {isShortsEnabled && (
                                <>
                                    {/* Başlık */}
                                    <div className="smt-form-group">
                                        <label>Shorts Başlığı</label>
                                        <input
                                            type="text"
                                            value={localYoutubeForm.title}
                                            onChange={(e) => setLocalYoutubeForm(prev => ({ ...prev, title: e.target.value }))}
                                            placeholder="YouTube Shorts başlığı (max 100 karakter)"
                                            maxLength={100}
                                        />
                                        <span className="smt-hint">{localYoutubeForm.title.length}/100</span>
                                    </div>

                                    {/* Açıklama */}
                                    <div className="smt-form-group">
                                        <label>Shorts Açıklaması</label>
                                        <textarea
                                            value={localYoutubeForm.description}
                                            onChange={(e) => setLocalYoutubeForm(prev => ({ ...prev, description: e.target.value }))}
                                            placeholder="Shorts açıklaması (opsiyonel)"
                                            rows={3}
                                            maxLength={5000}
                                        />
                                        <span className="smt-hint">{localYoutubeForm.description.length}/5000</span>
                                    </div>

                                    {/* Kategori */}
                                    <div className="smt-form-group">
                                        <label>Video Kategorisi</label>
                                        <select
                                            value={localYoutubeForm.categoryId}
                                            onChange={(e) => setLocalYoutubeForm(prev => ({ ...prev, categoryId: e.target.value }))}
                                        >
                                            {youtubeCategories.map(cat => (
                                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* YouTube Video Bölümü */}
                        <div className={`smt-youtube-section ${!isVideoEnabled ? 'disabled' : ''}`}>
                            <div className="smt-section-header">
                                <h4>YouTube Video {isVideoEnabled ? '(Aktif)' : '(Devre Dışı)'}</h4>
                                {!isVideoEnabled && videoDuration && (
                                    <span className="smt-disabled-reason">Video 60 saniyeden kısa</span>
                                )}
                            </div>

                            {isVideoEnabled && (
                                <>
                                    {/* Başlık */}
                                    <div className="smt-form-group">
                                        <label>Video Başlığı</label>
                                        <input
                                            type="text"
                                            value={localYoutubeForm.title}
                                            onChange={(e) => setLocalYoutubeForm(prev => ({ ...prev, title: e.target.value }))}
                                            placeholder="YouTube video başlığı (max 100 karakter)"
                                            maxLength={100}
                                        />
                                        <span className="smt-hint">{localYoutubeForm.title.length}/100</span>
                                    </div>

                                    {/* Açıklama */}
                                    <div className="smt-form-group">
                                        <label>Video Açıklaması</label>
                                        <textarea
                                            value={localYoutubeForm.description}
                                            onChange={(e) => setLocalYoutubeForm(prev => ({ ...prev, description: e.target.value }))}
                                            placeholder="Video açıklaması (opsiyonel)"
                                            rows={4}
                                            maxLength={5000}
                                        />
                                        <span className="smt-hint">{localYoutubeForm.description.length}/5000</span>
                                    </div>

                                    {/* Kategori */}
                                    <div className="smt-form-group">
                                        <label>Video Kategorisi</label>
                                        <select
                                            value={localYoutubeForm.categoryId}
                                            onChange={(e) => setLocalYoutubeForm(prev => ({ ...prev, categoryId: e.target.value }))}
                                        >
                                            {youtubeCategories.map(cat => (
                                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Not: Gizlilik ayarı kaldırıldı, her zaman "public" olacak */}
                        <div className="smt-info-box" style={{ marginTop: '15px' }}>
                            <span>ℹ️</span>
                            <p>Tüm YouTube videoları "Herkese Açık" olarak yüklenecektir.</p>
                        </div>
                    </div>
                </div>
            );
        }

        if (platform.id === 'x') {
            const originalText = contentForm.content || '';
            const charCount = (xSettings.text || originalText).length;
            const isOverLimit = charCount > 280;

            return (
                <div className="smt-details-panel">
                    <div className="smt-x-settings">
                        <h4>X (Twitter) Ayarları</h4>

                        {/* Tweet Metni */}
                        <div className="smt-form-group">
                            <label>Tweet Metni</label>
                            <textarea
                                value={xSettings.text || ''}
                                onChange={(e) => {
                                    const text = e.target.value;
                                    if (text.length <= 280) {
                                        setXSettings(prev => ({
                                            ...prev,
                                            text: text,
                                            useOriginal: false,
                                            charCount: text.length
                                        }));
                                    } else {
                                        toast.warning('Tweet 280 karakterden uzun olamaz');
                                    }
                                }}
                                placeholder={hasGirlsTag && originalText ? `Varsayılan: "${originalText.substring(0, 50)}..."` : "Tweet metninizi yazın (max 280 karakter)"}
                                rows={4}
                                maxLength={280}
                                className={charCount > 260 ? 'near-limit' : ''}
                            />
                            <div className="smt-char-counter">
                                <span className={charCount > 260 ? 'text-warning' : ''}>
                                    {xSettings.text ? xSettings.text.length : 0} / 280
                                </span>
                                {charCount > 260 && charCount <= 280 && (
                                    <span className="smt-hint">Limite yaklaşıyorsunuz</span>
                                )}
                            </div>

                            {/* Bilgi mesajı */}
                            <div className="smt-info-text" style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
                                💡 {hasGirlsTag ? 'Boş bırakırsanız orijinal içerik metni kullanılır (280 karaktere kısaltılarak)' : 'Boş bırakırsanız metin boş olarak paylaşılır'}
                            </div>
                        </div>

                        {/* Media Bilgisi */}
                        {mediaPreviews.length > 0 && (
                            <div className="smt-info-box">
                                <span>🖼️</span>
                                <p>
                                    {mediaPreviews.length} medya dosyası tweet'e eklenecek.
                                    {mediaPreviews.some(p => p.type === 'video') && ' (Video max 2:20 dk)'}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        if (platform.id === 'tiktok') {
            const hasVideo = bulkMode || mediaPreviews.some(p => p.type === 'video') ||
                (isEditMode && existingMedia.some(m => m?.type === 'video' || m?.mimetype?.startsWith('video/')));

            const originalText = contentForm.content || '';

            return (
                <div className="smt-details-panel">
                    <div className="smt-tiktok-settings">
                        <h4>TikTok Ayarları</h4>

                        {/* Video Kontrolü */}
                        {!hasVideo && (
                            <div className="smt-warning-box">
                                <span>⚠️</span>
                                <p>TikTok için video yüklemeniz gerekiyor. Medya sekmesinden video ekleyin.</p>
                            </div>
                        )}

                        {hasVideo && (
                            <>
                                {/* Video Başlığı */}
                                <div className="smt-form-group">
                                    <label>Video Açıklaması</label>
                                    <textarea
                                        value={tiktokSettings?.caption || ''}
                                        onChange={(e) => {
                                            const caption = e.target.value;
                                            if (caption.length <= 2200) {
                                                setTiktokSettings(prev => ({
                                                    ...prev,
                                                    caption: caption
                                                }));
                                            } else {
                                                toast.warning('TikTok açıklaması 2200 karakterden uzun olamaz');
                                            }
                                        }}
                                        placeholder={hasGirlsTag && originalText ? `Varsayılan: "${originalText.substring(0, 50)}..."` : "TikTok video açıklaması (max 2200 karakter)"} rows={4}
                                        maxLength={2200}
                                    />
                                    <div className="smt-char-counter">
                                        <span>{(tiktokSettings?.caption || '').length} / 2200</span>
                                    </div>

                                    {/* Bilgi mesajı */}
                                    <div className="smt-info-text" style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
                                        💡 {hasGirlsTag ? 'Boş bırakırsanız orijinal içerik metni kullanılır' : 'Boş bırakırsanız boş metin paylaşılır'}
                                    </div>
                                </div>

                                {/* Hashtag'ler */}
                                <div className="smt-form-group">
                                    <label>Hashtag'ler</label>
                                    <input
                                        type="text"
                                        value={tiktokSettings?.hashtags || ''}
                                        onChange={(e) => setTiktokSettings(prev => ({
                                            ...prev,
                                            hashtags: e.target.value
                                        }))}
                                        placeholder="#trending #viral #fyp (boşlukla ayırın)"
                                    />
                                    <span className="smt-hint">Hashtag'leri boşlukla ayırın</span>
                                </div>

                                {/* Yorumlara İzin Ver */}
                                <div className="smt-form-group">
                                    <label className="smt-checkbox-label">
                                        <input
                                            type="checkbox"
                                            checked={tiktokSettings?.allowComments !== false}
                                            onChange={(e) => setTiktokSettings(prev => ({
                                                ...prev,
                                                allowComments: e.target.checked
                                            }))}
                                        />
                                        <span>Yorumlara izin ver</span>
                                    </label>
                                </div>

                                {/* Düet/Stitch İzni */}
                                <div className="smt-form-group">
                                    <label className="smt-checkbox-label">
                                        <input
                                            type="checkbox"
                                            checked={tiktokSettings?.allowDuet !== false}
                                            onChange={(e) => setTiktokSettings(prev => ({
                                                ...prev,
                                                allowDuet: e.target.checked
                                            }))}
                                        />
                                        <span>Düet ve Stitch'e izin ver</span>
                                    </label>
                                </div>

                                {/* Video Süresi Bilgisi */}
                                {videoDuration && (
                                    <div className="smt-info-box" style={{ marginTop: '15px' }}>
                                        <span>🎬</span>
                                        <p>
                                            Video süresi: <strong>{videoDuration} saniye</strong>
                                            {videoDuration <= 60 && ' - TikTok için ideal süre'}
                                            {videoDuration > 180 && ' - ⚠️ Maksimum 3 dakika olmalı'}
                                        </p>
                                    </div>
                                )}

                                {/* Gizlilik Bilgisi */}
                                <div className="smt-info-box" style={{ marginTop: '15px' }}>
                                    <span>ℹ️</span>
                                    <p>Tüm TikTok videoları "Herkese Açık" olarak paylaşılacaktır.</p>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            );
        }

        if (platform.id === 'instagram') {
            const hasMedia = bulkMode || mediaPreviews.length > 0 ||
                (isEditMode && existingMedia.length > 0);

            const hasVideo = mediaPreviews.some(p => p.type === 'video') ||
                (isEditMode && existingMedia.some(m => m?.type === 'video' || m?.mimetype?.startsWith('video/')));

            const hasPhoto = mediaPreviews.some(p => p.type === 'image') ||
                (isEditMode && existingMedia.some(m => m?.type === 'image' || m?.mimetype?.startsWith('image/')));

            const originalText = contentForm.content || '';

            // Instagram content type'ı belirle
            const getDefaultContentType = () => {
                if (hasVideo && !hasPhoto) return 'reel';
                if (hasPhoto) return 'post';
                return 'post';
            };

            // State yoksa başlat
            if (!instagramSettings) {
                setInstagramSettings({
                    contentType: getDefaultContentType(),
                    caption: '',
                    firstComment: '',
                    collaborators: '',
                    userTags: ''
                });
            }

            return (
                <div className="smt-details-panel">
                    <div className="smt-instagram-settings">
                        <h4>Instagram Ayarları</h4>

                        {/* Medya Kontrolü */}
                        {!hasMedia && (
                            <div className="smt-warning-box">
                                <span>⚠️</span>
                                <p>Instagram için en az bir medya dosyası gereklidir. Medya sekmesinden resim veya video ekleyin.</p>
                            </div>
                        )}

                        {hasMedia && (
                            <>
                                {/* İçerik Tipi Seçimi */}
                                <div className="smt-form-group">
                                    <label>Paylaşım Tipi</label>
                                    <div className="smt-content-type-selector">
                                        <button
                                            type="button"
                                            className={`smt-type-btn ${instagramSettings?.contentType === 'post' ? 'active' : ''} ${!bulkMode && !hasPhoto && hasVideo ? 'disabled' : ''}`}
                                            onClick={() => {
                                                if (bulkMode || hasPhoto || !hasVideo) {
                                                    setInstagramSettings(prev => ({
                                                        ...prev,
                                                        contentType: 'post'
                                                    }));
                                                }
                                            }}
                                            disabled={!bulkMode && !hasPhoto && hasVideo}
                                        >
                                            <span>📷</span>
                                            <span>Post</span>
                                        </button>

                                        <button
                                            type="button"
                                            className={`smt-type-btn ${instagramSettings?.contentType === 'reel' ? 'active' : ''} ${!bulkMode && !hasVideo ? 'disabled' : ''}`}
                                            onClick={() => {
                                                if (bulkMode || hasVideo) {
                                                    setInstagramSettings(prev => ({
                                                        ...prev,
                                                        contentType: 'reel'
                                                    }));
                                                }
                                            }}
                                            disabled={!bulkMode && !hasVideo}
                                        >
                                            <span>🎬</span>
                                            <span>Reels</span>
                                        </button>

                                        <button
                                            type="button"
                                            className={`smt-type-btn ${instagramSettings?.contentType === 'story' ? 'active' : ''}`}
                                            onClick={() => setInstagramSettings(prev => ({
                                                ...prev,
                                                contentType: 'story'
                                            }))}
                                        >
                                            <span>⏰</span>
                                            <span>Story</span>
                                        </button>
                                    </div>

                                    {/* İçerik tipi açıklamaları */}
                                    <div className="smt-type-description">
                                        {instagramSettings?.contentType === 'post' && (
                                            <p className="smt-hint">📷 Normal Instagram gönderisi - Resim veya video paylaşımı</p>
                                        )}
                                        {instagramSettings?.contentType === 'reel' && (
                                            <p className="smt-hint">🎬 Instagram Reels - Maksimum 90 saniye dikey video</p>
                                        )}
                                        {instagramSettings?.contentType === 'story' && (
                                            <p className="smt-hint">⏰ Instagram Story - 24 saat sonra otomatik silinir</p>
                                        )}
                                    </div>
                                </div>

                                {/* Caption/Açıklama */}
                                <div className="smt-form-group">
                                    <label>
                                        {instagramSettings?.contentType === 'story' ? 'Story Metni (Görünmez)' : 'Açıklama'}
                                    </label>
                                    <textarea
                                        value={instagramSettings?.caption || ''}
                                        onChange={(e) => {
                                            const caption = e.target.value;
                                            if (caption.length <= 2200) {
                                                setInstagramSettings(prev => ({
                                                    ...prev,
                                                    caption: caption
                                                }));
                                            } else {
                                                toast.warning('Instagram açıklaması 2200 karakterden uzun olamaz');
                                            }
                                        }}
                                        placeholder={
                                            instagramSettings?.contentType === 'story'
                                                ? "Story metni (kayıtlarda saklanır ama Story'de görünmez)"
                                                : hasGirlsTag && originalText
                                                    ? `Varsayılan: "${originalText.substring(0, 50)}..."`
                                                    : "Instagram açıklaması (max 2200 karakter)"
                                        }
                                        rows={4}
                                        maxLength={2200}
                                    />
                                    <div className="smt-char-counter">
                                        <span>{(instagramSettings?.caption || '').length} / 2200</span>
                                    </div>

                                    <div className="smt-info-text" style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
                                        💡 {hasGirlsTag ? 'Boş bırakırsanız orijinal içerik metni kullanılır' : 'Boş bırakırsanız metinsiz paylaşılır'}
                                    </div>
                                </div>

                                {/* Gelişmiş Seçenekler - Story hariç */}
                                {instagramSettings?.contentType !== 'story' && (
                                    <>
                                        {/* İlk Yorum */}
                                        <div className="smt-form-group">
                                            <label>İlk Yorum (Opsiyonel)</label>
                                            <input
                                                type="text"
                                                value={instagramSettings?.firstComment || ''}
                                                onChange={(e) => setInstagramSettings(prev => ({
                                                    ...prev,
                                                    firstComment: e.target.value
                                                }))}
                                                placeholder="Gönderiye otomatik ilk yorum ekle..."
                                                maxLength={2200}
                                            />
                                            <span className="smt-hint">Link ve CTA için ideal</span>
                                        </div>

                                        {/* İşbirlikçiler - Sadece Post ve Reels */}
                                        {(instagramSettings?.contentType === 'post' || instagramSettings?.contentType === 'reel') && (
                                            <div className="smt-form-group">
                                                <label>İşbirlikçiler (Max 3)</label>
                                                <input
                                                    type="text"
                                                    value={instagramSettings?.collaborators || ''}
                                                    onChange={(e) => setInstagramSettings(prev => ({
                                                        ...prev,
                                                        collaborators: e.target.value
                                                    }))}
                                                    placeholder="@kullanıcı1, @kullanıcı2, @kullanıcı3"
                                                />
                                                <span className="smt-hint">Virgülle ayırın, @ işareti opsiyonel</span>
                                            </div>
                                        )}

                                        {/* Kişi Etiketleme - Sadece Post ve resim varsa */}
                                        {instagramSettings?.contentType === 'post' && hasPhoto && (
                                            <div className="smt-form-group">
                                                <label>Kişi Etiketle (Sadece resimlerde)</label>
                                                <input
                                                    type="text"
                                                    value={instagramSettings?.userTags || ''}
                                                    onChange={(e) => setInstagramSettings(prev => ({
                                                        ...prev,
                                                        userTags: e.target.value
                                                    }))}
                                                    placeholder="@kullanıcı1, @kullanıcı2"
                                                />
                                                <span className="smt-hint">Fotoğrafta etiketlenecek kişiler</span>
                                            </div>
                                        )}
                                    </>
                                )}

                                {/* Video süresi bilgisi - Reels için */}
                                {instagramSettings?.contentType === 'reel' && videoDuration && (
                                    <div className="smt-info-box" style={{ marginTop: '15px' }}>
                                        <span>🎬</span>
                                        <p>
                                            Video süresi: <strong>{videoDuration} saniye</strong>
                                            {videoDuration <= 90 ? ' - Reels için uygun' : ' - ⚠️ Maksimum 90 saniye olmalı'}
                                        </p>
                                    </div>
                                )}

                                {/* Story Uyarısı */}
                                {instagramSettings?.contentType === 'story' && (
                                    <div className="smt-warning-box" style={{ marginTop: '15px', background: '#fff3cd', borderColor: '#ffeeba' }}>
                                        <span>⏰</span>
                                        <p>Story'ler 24 saat sonra otomatik olarak silinir</p>
                                    </div>
                                )}

                                {/* Business Hesap Uyarısı */}
                                <div className="smt-info-box" style={{ marginTop: '15px' }}>
                                    <span>ℹ️</span>
                                    <p>Instagram Business hesabı gereklidir. Personal hesaplar API üzerinden paylaşım yapamaz.</p>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            );
        }



        return null;
    };

    return (
        <div className="smt-social-media-tab">

            {/* Platform Listesi - Accordion Style - FİLTRELENMİŞ */}
            <div className="smt-platforms-list">
                {getFilteredPlatforms().map((platform) => (
                    <div
                        key={platform.id}
                        className="smt-platform-wrapper"
                        style={{
                            '--platform-color': getPlatformColor(platform.id)
                        }}
                    >
                        <div
                            className={`smt-platform-card ${expandedPlatform === platform.id ? 'smt-expanded' : ''} smt-${platform.status}`}
                            onClick={() => handlePlatformClick(platform.id)}
                        >
                            <div className="smt-platform-main">
                                <div className="smt-platform-left">
                                    <span className="smt-platform-icon" style={{ color: getPlatformColor(platform.id) }}>
                                        {platform.icon}
                                    </span>
                                    <div className="smt-platform-info">
                                        <h4 className="smt-platform-name">{platform.name}</h4>
                                        <p className="smt-platform-desc">{platform.description}</p>
                                    </div>
                                </div>
                                <div className="smt-platform-right">
                                    {platform.status === 'coming' && (
                                        <span
                                            className="smt-platform-status"
                                            style={{ backgroundColor: getStatusColor(platform.status) }}
                                        >
                                            {platform.statusText}
                                        </span>
                                    )}
                                    {/* Telegram için Yeni Buton Ekle butonu */}
                                    {platform.id === 'telegram' && expandedPlatform === platform.id && (
                                        <button
                                            type="button"
                                            className="smt-header-add-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setIsButtonsExpanded(!isButtonsExpanded);
                                            }}
                                            title="Yeni Buton Ekle"
                                        >
                                            + Yeni Buton Ekle
                                        </button>
                                    )}
                                    <span className={`smt-expand-icon ${expandedPlatform === platform.id ? 'expanded' : ''}`}>
                                        ▼
                                    </span>
                                </div>
                            </div>
                        </div>

                        {expandedPlatform === platform.id && platformSettings[platform.id] && (
                            <div className="smt-details-container">
                                {renderPlatformDetails(platform)}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* Link Modal */}
            {showLinkModal && (
                <div className="smt-modal-overlay" onClick={() => setShowLinkModal(false)}>
                    <div className="smt-modal" onClick={(e) => e.stopPropagation()}>
                        <h4>Link Ekle</h4>
                        <input
                            type="text"
                            placeholder="Link metni"
                            value={linkData.text}
                            onChange={(e) => setLinkData({ ...linkData, text: e.target.value })}
                        />
                        <input
                            type="url"
                            placeholder="https://example.com"
                            value={linkData.url}
                            onChange={(e) => setLinkData({ ...linkData, url: e.target.value })}
                        />
                        <div className="smt-modal-actions">
                            <button onClick={handleInsertLink} className="smt-btn-primary">Ekle</button>
                            <button onClick={() => setShowLinkModal(false)} className="smt-btn-secondary">İptal</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SocialMediaTab;